export default {
  instagram: 'Instagram',
  instagramcomments: 'Comentários no Instagram',
  facebook: 'Facebook',
  facebookinbox: 'Inbox do Facebook',
  facebookgroups: 'Grupos no Facebook',
  facebookcomments: 'Comentários no Facebook',
  youtube: 'YouTube',
  youtubecomments: 'Comentários no YouTube',
  twitter: 'Twitter',
  twitterinbox: 'Inbox do Twitter',
  tumblr: 'Tumblr',
  news: 'Portais',
  blogs: 'Blogs',
  foruns: 'Fóruns',
  comentariosemartigos: 'Comentários em Artigos',
  googleplay: 'Google Play',
  googleplus: 'Google Plus',
  googlemybusiness: 'Google Meu Negócio',
  foursquare: 'Foursquare',
  buscape: 'Avaliações de Produtos',
  reclameaqui: 'Reclame Aqui',
  linkedin: 'LinkedIn',
  linkedincomments: 'Comentários no LinkedIn',
  tv: 'TV',
  radio: 'Rádio',
  impressas: 'Impresso',
  portais: 'Portais',
  tiktok: 'TikTok',
  blip: 'Blip',
  importeddata: 'Dados Importados',
  bluesky: 'Bluesky',
  notclassified: 'Não Classificado',
};
